const SlotEvent = {};
export default SlotEvent;

SlotEvent.SELECTED = "SlotEvent.SELECTED";